import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { EsitoBadge, StatoBadge } from "@/components/Badges";
import { blurb } from "@/lib/cards";

export function MysteryCard({ d, voted, testid, className = "", style }) {
  const id = testid || `mystery-card-${d.id}`;
  return (
    <Link to={`/dossier/${d.id}`} data-testid={id} style={style}
      className={`luma-card group flex min-w-0 flex-col items-start p-[22px] hover:-translate-y-1 hover:border-[#BDA4E4] sm:p-6 ${className}`}>
      <div className="flex w-full flex-wrap items-center gap-2">
        <span className="luma-eyebrow">{d.categoria}</span>
        {d.esito && d.esito !== "aperto" && <EsitoBadge esito={d.esito} />}
        {d.stato && d.stato !== "pubblicato" && <StatoBadge stato={d.stato} />}
      </div>
      <h3 className="mt-4 text-[21px] font-extrabold leading-tight transition-colors group-hover:text-[var(--luma-action)] sm:text-[22px]">{d.titolo}</h3>
      <p className="mt-2 text-[15px] leading-relaxed text-[var(--luma-muted)]">{blurb(d)}</p>
      <div className="mt-auto flex w-full flex-wrap items-center justify-between gap-2 pt-4 text-sm font-bold">
        <span className="flex min-h-[44px] items-center gap-1.5 text-[var(--luma-action)]">Esplora le teorie <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" /></span>
        {voted && <span data-testid={`${id}-voted`} className="flex items-center gap-1 text-xs font-semibold text-[var(--luma-pink)]"><CheckCircle2 size={13} /> Hai già scelto</span>}
      </div>
    </Link>
  );
}
